import Lenis from 'lenis'



import { ChakraProvider } from '@chakra-ui/react'

// component
import Navbar from './component/Navbar/Navbar';
import Section1 from './component/Section_1/Section1';
import Portfolio from './pages/Portfolio/Portfolio';
import PostPortfolio from './pages/Portfolio/PostPortfolio';
import TermsAndConditions from './pages/TermsAndConditions';

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {

  React.useEffect(()=>{
    if (window.innerWidth < 600) {
      const lenis = new Lenis({
        duration: 0.1,
        smooth: true,
        smoothTouch: true,
      })

      function raf(time) {
        lenis.raf(time)
        requestAnimationFrame(raf)
      }
    
      requestAnimationFrame(raf)
    } else {
      const lenis = new Lenis({
        duration: 1,
        smooth: true,
        smoothTouch: true,
      })

      function raf(time) {
        lenis.raf(time)
        requestAnimationFrame(raf)
      }
    
      requestAnimationFrame(raf)
    }
  });

  



  return (
    <ChakraProvider>
      <Navbar/>
      
      <Router>
        <Routes>
          <Route path="/" element={<Section1/>} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/post/portfolio" element={<PostPortfolio />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
   
        </Routes>
      </Router>

    </ChakraProvider>
  );
}

export default App;
